module.exports = __webpack_public_path__ + "media/home/cta-4f4429f2.jpg";